import './orgTripStrap.css';
import Calendar from '../../assets/icons/trvto_calendar.svg';
import ReviewStars from '../reviewStars/ReviewStars';
import { getAmenities } from './tripStrapFun/amenities';
import image1 from '../../assets/images/trvto_tripDetails.jpg';
import { toPascalCase } from '../../utils/pascalCase';
import EditIcon from '../../assets/icons/trvto_edit_icon.svg';
import DuplicateIcon from '../../assets/icons/trvto_duplicate.png';
import { ReactComponent as Share } from '../../assets/icons/trvto_share.svg';
import { share } from '../../pages/tripDetails/tripDetailsFun/tripDetailsShare';
import Tooltip from '../tooltip/Tooltip';
import { useState } from 'react';

export default function OrgTripStrap({ page, setNav, data, setSelectedPack, selectedStatus, orgType }) {
    // const navigate = useNavigate('');

    // async function fetchPackData(id) {
    //     try {
    //         const result = await orgTripDetailsFun(id);
    //         return result.data; // Return the data directly
    //     } catch (error) {
    //         errorHandle(error);
    //         return null;
    //     }
    // }
    const [isDateCreated, setIsDateCreated] = useState(false);

    const handleTrip = (e, tripData, type) => {
        e.stopPropagation();
        if (orgType) {
            const url = `/org/${orgType}/create/pack?new=false&type=${type}&tripId=${tripData._id}`;
        }
        const url = `/org/create/pack?new=false&type=${type}&tripId=${tripData._id}`;
        window.open(url, '_blank');
    };

    return (
        <div>
            {selectedStatus === 'rejected' && (
                <div className='note-section'>
                    <p>
                        Note:{' '}
                        <span>
                            Click on the package to view the rejection comment. You can edit and resubmit the package.
                        </span>
                    </p>
                </div>
            )}
            {data?.map((data) => (
                <div
                    key={data._id}
                    className='org_tripStrap'
                    onClick={() => {
                        setNav(true);
                        setSelectedPack(data._id);
                    }}
                >
                    <div className='org_tripStrapContent'>
                        <div className='org_thumbImageContainer'>
                            <img
                                src={data.cardImages[0] ?? image1}
                                alt='trvto_trip'
                                className='org_tripStrapImage'
                                loading='lazy'
                                decoding='async'
                            />
                        </div>
                        <div className='org_tripStrapInfoDiv'>
                            <div className='org_tripStrapNameDiv alignCenter'>
                                <div className='org_tripStrapInfo'>
                                    <div className='org_tripStrapName'>
                                        <div className='alignCenter'>
                                            <p>{data?.title}</p>{' '}
                                            <Share className='deskHidden' onClick={(e) => share(e)} />
                                        </div>
                                        <div className='org_tripInfo'>
                                            {Array.isArray(data?.quickView?.type) &&
                                                data.quickView.type.includes('Trek') && (
                                                    <div className='org_typeInfo'>{data.quickView.type[0]}</div>
                                                )}
                                            <div className={`org_typeInfo ${data?.quickView?.difficulty}`}>
                                                {data?.quickView?.difficulty}
                                            </div>{' '}
                                            <div
                                                className={`org_typeInfo ${data?.status === 'active' ? 'active' : ''}`}
                                            >
                                                {toPascalCase(data?.status || ' ')}
                                            </div>
                                            <Share className='mobileHidden' onClick={(e) => share(e)} />
                                        </div>
                                    </div>
                                    <div className='org_tripCardNumInfo'>
                                        <ReviewStars rating={data?.rating} />
                                        <span>{data?.rating}</span>
                                        <p style={{ margin: 0 }}>({data?.reviewCount} Reviews)</p>
                                    </div>

                                    {data.type === 'rooms' && (
                                        <div className='org_amenities'>{getAmenities(data?.quickView?.amenities)}</div>
                                    )}
                                    {Array.isArray(data.quickView?.type) && data.quickView.type.includes('Trek') && (
                                        <div className='org_tripStrapDateDetails'>
                                            <div className='alignCenter'>
                                                <img src={Calendar} width={24} height={24} alt='trvto_calendar' />
                                                <span>
                                                    {data?.days} D, {data?.nights} N
                                                </span>
                                                <div className='divider' />
                                                <span className='innerStrap'>
                                                    <span className='innerStrapColumn'>
                                                        <span>{data?.quickView?.startTime}</span>
                                                        <label>|</label>
                                                        <span>{data?.quickView?.endTime}</span>
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                {data.datesType === 'fixed' && (
                                    <div className='org_tripStrapPriceDiv'>
                                        <div className='org_tripStrapPrDiv'>
                                            <p className='org_tripStrapPrice'>
                                                ₹ {data?.price[0]?.price.total}
                                                <span>/person</span>
                                            </p>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className='editDeleteBtn'>
                            <button className='org_tripEdit' onClick={(e) => handleTrip(e, data, 'duplicate')}>
                                <Tooltip content={'Duplicate'} position='bottom' className='tooltip-large'>
                                    <img src={DuplicateIcon} alt='edit' width={36} height={36} />
                                </Tooltip>
                            </button>
                            <button className='org_tripEdit' onClick={(e) => handleTrip(e, data, 'edit')}>
                                <Tooltip content={'Edit'} position='bottom' className='tooltip-large'>
                                    <img src={EditIcon} alt='edit' width={36} height={36} />
                                </Tooltip>
                            </button>
                        </div>
                    </div>
                    <div className='orgCreateDateContainer'>
                        <button
                            className='orgCreateDate'
                            onClick={(e) => {
                                e.stopPropagation();
                                setIsDateCreated((prev) => !prev);
                            }}
                        >
                            Create Date
                        </button>
                    </div>
                    <div>
                        {Array.isArray(data.quickView?.type) && data.quickView.type.includes('Trek') && (
                            <>
                                <div className='org_tripDivider org_holidayDivider' />
                                <p className='org_locationInfo'>
                                    Pickup Cities: <span>{data?.quickView?.baseCities}</span>
                                </p>
                            </>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}
